/* eslint-disable linebreak-style */
import base32 from 'base-32';


export const encode = (value) => {
  let encoded = base32.encode(value);
  encoded += '=';
  return encoded;
};
export const decode = value => base32.decode(value);

export default encode;
